/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upsell_History_TitleInputs */



/**
* | output |
* | --- |
* | "Older history comes with {tier}" |
*
* @param {Upsell_History_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const upsell_history_title = /** @type {((inputs: Upsell_History_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upsell_History_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Более ранняя история — на тарифе ${i?.tier}`)
	return /** @type {LocalizedString} */ (`Older history comes with ${i?.tier}`)
});